/**
 * Shared status/error banner with the correct live-region semantics.
 *
 * - `warn` banners are errors → role="alert" (implicit aria-live="assertive"),
 *   announced immediately when they appear.
 * - everything else (success / info / plain notices) → role="status"
 *   (implicit aria-live="polite"), announced without interrupting.
 *
 * Use this for dynamically-appearing feedback only; static informational
 * banners don't need a live region.
 */

type BannerVariant = 'info' | 'warn' | 'success';

export function Banner({
  variant,
  style,
  children,
}: {
  variant?: BannerVariant;
  style?: preact.JSX.CSSProperties;
  children: preact.ComponentChildren;
}): preact.ComponentChildren {
  return (
    <div
      class={variant ? `banner ${variant}` : 'banner'}
      role={variant === 'warn' ? 'alert' : 'status'}
      style={style}
    >
      {children}
    </div>
  );
}
